// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DraftComboboxValue__draftComboboxValue___Pqpiy {
    display: inline-block;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/DraftCombobox/DraftComboboxValue/DraftComboboxValue.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,WAAW;AACf","sourcesContent":[".draftComboboxValue {\n    display: inline-block;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"draftComboboxValue": `DraftComboboxValue__draftComboboxValue___Pqpiy`
};
export default ___CSS_LOADER_EXPORT___;
